import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Typography from '@material-ui/core/Typography'
import { UploadImageViewType, UseUploadImageType } from './uploadImageType'
import useUploadImage from './useUploadImage'
import useTranslate from '../../i18n/useTranslate'

const UploadImageView = (props: UploadImageViewType) => {
    const {
        name,
        label,
        labelTitle,
        refElementUpload,
        onClickUpload,
        onChangeUpload,
        color,
        required = false,
        disabled = false,
        field: { meta },
    } = props
    const isError = !disabled && meta.error && meta.touched ? true : false
    const classes = useStyles(isError)
    const t = useTranslate()
    const buttonColor = color ? color : 'default'

    return (
        <FormControl>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant={'subtitle2'} className={classes.label}>
                    {label}
                </Typography>
                <Typography variant={'subtitle2'} style={{ color: '#FF0000' }}>
                    {required && ' *'}
                </Typography>
            </div>
            <input
                accept="image/*"
                type="file"
                name={name}
                id={name}
                ref={refElementUpload}
                onChange={onChangeUpload}
                hidden
            />
            <FormHelperText style={{ fontFamily: 'prompt', fontSize: '12px', color: '#ff4d4f' }}>
                {isError && meta.error}
            </FormHelperText>
            <Button variant="contained" color={buttonColor} onClick={onClickUpload}>
                {labelTitle ? `${labelTitle}` : `${t.get('BUTTON.CHOOSE_FILE')}`}
            </Button>
        </FormControl>
    )
}

const UploadImage = (props: UseUploadImageType) => {
    const useUploadImageModel = useUploadImage(props)
    return <UploadImageView {...props} {...useUploadImageModel} />
}

export default UploadImage

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: 10,
    },
}))
